<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col pl-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div  class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
<div class="col-12">
  <h4 class="mb-2 py-1 font-header-1">Vendor List</h4>
</div>
    <div class="col pl-0 mb-2">
      <div widget class="card border-0 box-shadow">
         <div class="card-body  widget-body pb-0 pt-2 mb-4">
          <div class="row mb-2">
            <div class="col-lg-4 col-sm-12 col-xs-12">            
             
            <button type="button" class="btn blue-btn btn-sm text_left mr-2"
            data-bs-toggle="modal" data-bs-target="#casemodalopen"
            (click)="CaseCreateupdate('new')"  *ngIf="fp.vendorcreate"> Add Vendor </button>
            </div>
            
            <div class="col text-right text-end ">
              <button type="button" class="btn blue-btn btn-sm butstyle ms-1"
               
                (click)="exportCsv()">
                <i class="fa fa-file-excel-o me-1"></i>ExportAsCSV</button>&nbsp;&nbsp;


            </div>

          </div>
             <!-- =======================================================ejs grid==================================================================== -->
          <div class="row mt-2">
            <div class="col ">
              <ejs-grid #grid id="grid"   [dataSource]='data | async'    [allowResizing]='true' allowPaging='true'
              [allowSorting]='true' [allowPaging]='true'  [pageSettings]='initialPage' 
               [allowFiltering]='true'
              [filterSettings]='filterOptions'  (dataStateChange)='dataStateChange($event)' 
              (actionBegin)="onActionComplete($event)" [showColumnChooser]="true"> 
              <e-columns>
                <e-column width=150  uid="action" headerText="Actions" [showInColumnChooser]='false'>
                  <ng-template #template let-data>
                    <button  class="btn btn-edit-table" data-bs-toggle="modal"  data-bs-target="#casemodalopen" 
                    (click)="editvendor(data);CaseCreateupdate('edit')" *ngIf="fp.vendorupdate"
                    ><i class="fa fa-edit"></i></button>&nbsp;
                     
                      <button class="btn btn-delete-table"  *ngIf="fp.vendordelete"
                       (click)="infoToast()"><i
                        class="fa fa-trash"></i></button>
                </ng-template>
                </e-column>
                <e-column minWidth=150 field="name" headerText="Vendor Name" type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="companyName" headerText="Vendor Company Name" type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="phone" headerText="Phone" type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=130 field="email" headerText="Email" type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="street" headerText="Street" type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
                <e-column minWidth=100 field="statusLovName" headerText="Status" type='string'>
                  <ng-template #filterTemplate let-data>
                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                  </ng-template>
                </e-column>
      
      
              </e-columns>
            </ejs-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



  

  
  


 <!------------------------------------------------------------------- Modal---------------------------------------------------- -->
 
 <span id="opencasemanModal1" data-bs-target="#casemodalopen" data-bs-toggle="modal"></span>
 <div class="modal fade" id="casemodalopen" tabindex="-1" role="dialog" 
 aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-lg" role="document" modal-xl>
      <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title font-header" id="exampleModalLabel"  *ngIf="ModelType =='new'">Create Vendor </h5>
                 <h5 class="modal-title font-header" id="exampleModalLabel"*ngIf="ModelType =='edit'" >Update Vendor
                  </h5> 
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true"></span>
            </button>
        </div>
        <div class="modal-body">
        
            <div class="row">
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Status<sup class="super-script">*</sup>
                            </label>
                        </div>
                        <div class="col-lg-7">
                            <ng-select class="w-100" [items]="statuslist" [searchable]="true" 
                            [clearable]="true"  [(ngModel)]="vendor.statusLid" bindLabel="lovName"
                                bindValue="id">
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>Vendor Name<sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control"  [(ngModel)]="vendor.name">
                        </div>
                    </div>

                </div>

            </div>


            <div class="row mt-1">
                <div class="col-lg-6 ">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>companyName<sup class="super-script">*</sup></label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control"    [(ngModel)]="vendor.companyName">
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-5">
                        <label>Email<sup class="super-script">*</sup></label>
                    </div>
                    <div class="col-lg-7">
                        <input type="text" class="form-control"  [(ngModel)]="vendor.email" >
                    </div></div>
                    </div>
                   
            </div>
           
            <div class="row mt-1">
      
                <div class="col-lg-6">
                    <div class="row"[formGroup]="form"  >
                        <div class="col-lg-5">
                            <label>Phone</label>
                        </div>
                        <div class="col-lg-7">
                          <input type="text"  [(ngModel)]="vendor.phone"  formControlName="phone"
                          minlength="14" maxlength="14" class="form-control"  (ngModelChange)="PhoneFormat('phone')"
                         (keypress)="keyPress($event)">
                        </div>
                    </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="row ">
                            <div class="col-lg-5">
                                <label>State</label>
                            </div>
                            <div class="col-lg-7">
                                <ng-select  [(ngModel)]="vendor.state" [items]="stateList" class="width25" [searchable]="true"
                               [clearable]="true" bindLabel="name" bindValue="abbreviation" >
                                 </ng-select>
                               </div>
                        </div>
                        </div>
              </div>

              
              <div class="row mt-1">
      
                <div class="col-lg-6">
                    <div class="row ">
                        <div class="col-lg-5">
                            <label>Street</label>
                        </div>
                        <div class="col-lg-7 col-md-7">
                            <input type="text" [(ngModel)]="vendor.street"  class="form-control" >
                             </div>
                    </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="row ">
                            <div class="col-lg-5">
                                <label>City</label>
                            </div>
                            <div class="col-lg-7">
                                <input type="text"  [(ngModel)]="vendor.city" 
                                class="form-control">
                            </div>
                        </div>
                        </div>
            </div>
            <div class="row mt-1" [formGroup]="form" >
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-5">
                            <label>ZipCode</label>
                        </div>
                        <div class="col-lg-7">
                            <input type="text" class="form-control"  formControlName="zipCode"
                              minlength="5" (keypress)="numberOnly($event)"
                             maxlength="11"  
                             [(ngModel)]="vendor.zipCode">
                             <div class="error" *ngIf="form.controls['zipCode'].touched && form.controls['zipCode'].invalid" > 
                              Enter Valid five digit number</div>
                            
                        </div>
                    </div>
                    </div>
             </div>

             <div class="row mt-1">
              <div class="col-lg-6">
                  <div class="row">
                      <div class="col-lg-5">
                          <label>TaxId</label>
                      </div>
                      <div class="col-lg-7">
                      <input type="text"  class="form-control" [(ngModel)]="vendor.taxId" 
                       (keypress)="keyPress($event)">
                          
                         </div>
                  </div>
                  </div>
          </div>

           
          

        </div>
        <div class="modal-footer">
            <button class="btn blue-btn btn-sm" *ngIf="ModelType =='new'" (click)="SaveVendor('new')"
            [disabled]="(vendor.name=='' || vendor.name==undefined ||vendor.companyName=='' 
            || vendor.companyName==undefined || vendor.statusLid=='' || vendor.statusLid==undefined || vendor.email=='' ||
            vendor.email==undefined)"> Save & Close </button>
          
            <button class="btn blue-btn btn-sm" *ngIf="ModelType =='edit'" (click)="SaveVendor('edit')" 
            [disabled]= "(vendor.name=='' || vendor.name==undefined ||vendor.companyName=='' 
            || vendor.companyName==undefined || vendor.statusLid=='' || vendor.statusLid==undefined || vendor.email=='' ||
            vendor.email==undefined) "> Update & Close </button>
       
              <button type="button" class="btn btn-sm" data-bs-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>

  <!-- =============================================Deletevendor============================================================== -->
  <span id="openModal2" data-bs-target="#deletevendor" data-bs-toggle="modal"></span>
  <div class="modal fade modalbackgrod" id="deletevendor" data-bs-backdrop="static">
    <div class="modal-dialog delete-zip" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title font-header">Delete Record</h5>
          <button type="button" class="btn-close"aria-label="Close" data-bs-dismiss="modal">
            <span aria-hidden="true"></span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-lg-12">
              <label>Do you want to delete this record ?</label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn blue-btn btn-sm"(click)="deleteVendor()" >Delete</button>
          <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
<!-- ==============close without save modal================================= -->
<span id="cancelcasemanmodal" data-bs-toggle="modal" data-bs-target="#ClosecasemanModal"></span>
<div class="modal fade primarymodal modalbackgrod" id="ClosecasemanModal" tabindex="-1" role="dialog"
 aria-labelledby="exampleModalLabel" aria-hidden="true" >
    <div class="modal-dialog create-update-zip" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header" id="exampleModalLabel" >Close</h5>
                <button type="button" class="btn-close"data-bs-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
              You want to close without save?
            </div>
            <div class="modal-footer">
            <button type="button" class="btn blue-btn btn-sm">Yes</button>
            <button type="button" class="btn blue-btn btn-sm" data-bs-dismiss="modal">No</button>
            </div>
        </div>
    </div>
</div>


 
   
